<template>
  <transition name="background-mask-transition">
    <div v-if="show" class="background-mask-container">
      <div class="background-mask" @click="$emit('maskClicked')"></div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['show'],
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.background-mask {
  z-index: 11;
  top: 0;
  position: fixed;
  height: 100vh;
  width: 100%;
  background-color: var(--overlay-color);
  transition: background-color 150ms ease-in-out;
}

.background-mask-transition-enter-from,
.background-mask-transition-leave-to {
  .background-mask {
    background-color: var(--overlay-color);
  }
}
</style>
